<template>
	<b-modal
		id="agentmodal"
		size="lg"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		:no-close-on-esc="true"
	>
		<div
			class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
		>
			Alert !
		</div>
		<div @click="$bvModal.hide('agentmodal')" class="modalcloseicon pointer">
			<img
				class="rotate-on-hover"
				src="../../assets/newimgs/closeicon.svg"
				alt=""
			/>
		</div>
		<div
			class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
		>
			<div>
				<img src="../../assets/newui-img/alertimage.svg" />
			</div>
			<div class="newui-modal-bodytxt mt-4 mb-3">
				"Agent not working!!!" <br />
				Please follow the below steps
			</div>
			<div class="mt-2 step-subtext text-center">
				1. Go to windows and search “Hire3x Proctoring Agent”, and allow all the
				permissions to install again. (If already installed follow the below
				step)
			</div>
			<div class="mt-3 step-subtext text-center">
				2. If the application is installed correctly then it will appear in the
				“System tray”, right-click on the application in the System tray and
				select "Start service".
			</div>
			<div class="bluebtns mt-5">
				<b-button
					class="mr-1 px-5"
					variant="primary"
					@click="$bvModal.hide('agentmodal')"
					>Okay</b-button
				>
			</div>
		</div>
	</b-modal>
</template>
<script>
export default {
	name: "CheckAgentModal",
};
</script>
